export default __webpack_public_path__ + "static/media/include_2_male@3x.9dacfea4.jpg";